import {Injectable} from '@angular/core';
import {LocalStorageService} from './local.storage.service';
import {UserService} from './user.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor(private userService: UserService,
              private localStorageService: LocalStorageService) {
  }

  getProjectDetails(projectType: string): any {
    console.log(projectType);
    let projectList = this.localStorageService.get('project_list');
    if (projectList === undefined || projectList.length === 0) {
      this.userService.getProjectData()
        .subscribe({
          next: (value: any) => {
            projectList = value;
          }
        });
    }
    if (projectType) {
      const projectObj = projectList.find((obj: any) => obj.ref === projectType);
      if (projectObj === undefined) {
        return {name: 'All projects', ref: 'ap', projectFirstWord: 'All', projectSecondWord: 'projects'};
      }
      return projectObj;
    } else {
      return projectList[1];
    }
  }

  getProjectLogo(projectType: string): string[] {
    let projectTypeImage = '';
    let darkProjectTypeImage = '';
    if (projectType) {
      if (projectType === 'ic') {
        projectTypeImage = 'assets/img/logo/LOGO-IC.svg';
        darkProjectTypeImage = 'assets/img/logo/DARK-LOGO-IC.svg';
      } else if (projectType === 'yarn') {
        projectTypeImage = 'assets/img/logo/LOGO-YC.svg';
        darkProjectTypeImage = 'assets/img/logo/DARK-LOGO-YC.svg';
      } else if (projectType === 'space') {
        projectTypeImage = 'assets/img/logo/light-CARINGSPACES.svg';
        darkProjectTypeImage = 'assets/img/logo/CARINGSPACES.svg';
      } else if (projectType === 'act') {
        projectTypeImage = 'assets/img/logo/youact.svg';
        darkProjectTypeImage = 'assets/img/logo/dark-youact.svg';
      } else if (projectType === 'paint') {
        projectTypeImage = 'assets/img/logo/LOGO-PR.svg';
        darkProjectTypeImage = 'assets/img/logo/DARK-LOGO-PR.svg';
      } else if (projectType === 'codeRed') {
        projectTypeImage = 'assets/img/logo/LOGO-CR.svg';
        darkProjectTypeImage = 'assets/img/logo/DARK-LOGO-CR.svg';
      } else {
        projectType = 'ap';
        projectTypeImage = 'assets/img/logo/LOGO-AP.svg';
        darkProjectTypeImage = 'assets/img/logo/DARK-LOGO-AP.svg';
      }
    } else {
      projectType = 'space';
      projectTypeImage = 'assets/img/logo/light-CARINGSPACES.svg';
      darkProjectTypeImage = 'assets/img/logo/CARINGSPACES.svg';
      // @TODO for you-act event
      /*projectType = 'ap';
      projectTypeImage = 'assets/img/logo/LOGO-AP.svg';
      darkProjectTypeImage = 'assets/img/logo/DARK-LOGO-AP.svg';*/
    }
    return [projectType, projectTypeImage, darkProjectTypeImage];
  }
}
